export const blackButtonStyles = {
  marginRight: 2,
  size: 'sm',
  backgroundColor: 'primary.900',
  _hover: {
    backgroundColor: 'primary.800',
  },
  _active: {
    backgroundColor: 'primary.700',
  },
  _disabled: {
    backgroundColor: 'primary.400',
  },
  borderWidth: '1px',
  borderColor: 'white',
  color: 'white',
};

export const blackIconStyles = {
  color: 'white',
  boxSize: 4,
};

export const whiteButtonStyles = {
  backgroundColor: 'neutral.200',
  _hover: {
    backgroundColor: 'neutral.300',
  },
  _active: {
    backgroundColor: 'neutral.400',
  },
  _disabled: {
    backgroundColor: 'neutral.100',
  },
  color: 'primary.500',
};
